import { errorToast } from "@/v2-ui/toast"
import Manage from "@/v2-backoffice-client/components/manage"
import { useTenantQuery } from "@/v2-backoffice-client/tenant/tenant.query"
import type { TenantFragment } from "@/v2-backoffice-client/tenant/__types__/tenant.fragment"
import UserTenantManageSearchItem from "@/v2-backoffice-client/user/tenant/manage/UserTenantManageSearchItem"

const MIN_SEARCH_LENGTH = 2

export type UserTenantManageSearchProps = {
  open: boolean
  userId: number
  debouncedSearch: string
  isMember(tenantId: number): boolean
  onAdded(tenant: TenantFragment, roleCode: number): void
}

function UserTenantManageSearch(props: UserTenantManageSearchProps) {
  const { open, userId, debouncedSearch, isMember, onAdded } = props

  const hasQuery = debouncedSearch.length >= MIN_SEARCH_LENGTH

  const { data, loading, error } = useTenantQuery({
    skip: !open || !hasQuery,
    variables: {
      input: {
        limit: 10,
        filters: hasQuery
          ? [{ column: "Name", contains: debouncedSearch }]
          : undefined,
      },
    },
  })

  errorToast(error, { title: "Failed to search teams" })

  const tenants = data?.getTenants.items ?? []
  const results = tenants.filter((tenant) => !isMember(tenant.Id))

  return (
    <Manage.Section
      label={`Teams not yet member a of${results.length > 0 ? ` (${results.length})` : ""}`}
      className="border-t border-border"
    >
      {!hasQuery && (
        <Manage.Hint>
          Type at least {MIN_SEARCH_LENGTH} characters to search
        </Manage.Hint>
      )}

      {hasQuery && loading && <Manage.Skeleton count={3} />}
      {hasQuery && !loading && results.length === 0 && (
        <Manage.Empty>
          No teams found that the user isn&apos;t already a member of
        </Manage.Empty>
      )}

      {hasQuery && !loading && results.length > 0 && (
        <Manage.List variant="results">
          {results.map((tenant) => (
            <UserTenantManageSearchItem
              key={tenant.Id}
              tenant={tenant}
              userId={userId}
              onAdded={(roleCode) => onAdded(tenant, roleCode)}
            />
          ))}
        </Manage.List>
      )}
    </Manage.Section>
  )
}

export default UserTenantManageSearch
